"use client";

import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";

type PageTitleContextType = {
  title: string;
  setTitle: (title: string) => void;
};

const PageTitleContext = createContext<PageTitleContextType>({
  title: "",
  setTitle: () => {},
});

export type PageTitleProviderProps = {
  children: ReactNode;
};

export const PageTitleProvider = ({ children }: PageTitleProviderProps) => {
  const [title, setTitleState] = useState("");
  const setTitle = useCallback((nextTitle: string) => setTitleState(nextTitle), []);

  return (
    <PageTitleContext.Provider value={{ title, setTitle }}>{children}</PageTitleContext.Provider>
  );
};

export const usePageTitle = () => useContext(PageTitleContext);

export type PageTitleProps = {
  title: string;
};

export const PageTitle = ({ title }: PageTitleProps) => {
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle(title);

    return () => {
      setTitle("");
    };
  }, [title, setTitle]);

  return null;
};
